'use strict';

angular.module('shiftTraderApp')
  .directive('saNotePermissions', ['saNotePermissionLevels', function(permissionLevels) {
    return {
      restrict: 'A',
      templateUrl: 'views/directives/notes/saNotePermissions.html',
      require: '^saNoteCreate',
      controllerAs: 'PermissionsCtrl',
      controller: ['$scope', function($scope) {
        var vm = this;

        vm.levels = permissionLevels;

        // Define select permission method
        vm.selectPermission = function(permissionId) {
          if(vm.levels[permissionId]) {
            vm.selected = vm.levels[permissionId];
            $scope.NoteCtrl.setNotePermission(permissionId);
          } else {
            console.error(permissionId + ': No such permission level.');
          }
        };

        // Select permission belonging to this note, or public if not recognized
        var selectedPerm = $scope.NoteCtrl.note.permission || 0;
        vm.selectPermission(selectedPerm);

        return vm;

      }],
      link: function(scope, element, attrs, parentCtrl) {
        scope.NoteCtrl = parentCtrl;
      }
    }
  }]);
